import moment from "moment";

/**
 * return Month and year
 * @returns 
 */
Date.prototype.getShortMonthYearName = function() {
	const month = this.getMonth() + 1;
	return (month < 10 ? "0" + month : month) + "/" + this.getFullYear();
};

/**
 * return full date
 * @returns 
 */
Date.prototype.getFullDate = function() {
	return this.getMonth() + 1 + "/1/" + this.getFullYear();
};

const today = new Date();

/**
 * default as of date
 */
const defaultAsofDate = {
	textValue: today.getShortMonthYearName(),
	date: today.getFullDate()
};

/**
 * current date
 * @returns 
 */
function getTodaysDate() {
	const today = new Date();
	return convertDateToFormat(today);
}

/**
 * as of date
 * @returns 
 */
function getAsofDate() {
	const asofDate =
		JSON.parse(localStorage.getItem("ASOFDATE")) || defaultAsofDate;
	return asofDate;
}

/**
 * convert date format
 * @param {*} today 
 * @returns 
 */
function convertDateToFormat(today) {
	const dd = String(today.getDate()).padStart(2, "0");
	const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
	const yyyy = today.getFullYear();
	today = mm + "/" + dd + "/" + yyyy;
	return today;
}

/**
 * code to convert date to local date
 * @param {*} date 
 * @param {*} format 
 * @returns 
 */
function convertToLocalDate(date, format = "MM/DD/YYYY") {
	const formattedDate= moment(moment.utc(date).toDate()).format(format);
	return date ? formattedDate : "";
}

/**
 * addition of year into given date
 * @param {*} _date 
 * @param {*} addYearValue 
 * @returns 
 */
function addYearIntoDate(_date, addYearValue = 1) {
	const date = getDate(_date);
	date.setFullYear(date.getFullYear() + addYearValue);
	return convertDateToFormat(date);
}

/**
 * addition of day into given date
 * @param {*} _date 
 * @param {*} addDays 
 * @returns 
 */
function addDayIntoDate(_date, addDays = 1) {
	const date = getDate(_date);
	date.setDate(date.getDate() + addDays);
	return date;
}

/**
 * subtraction of day from given date
 * @param {*} _date 
 * @param {*} subtractDays 
 * @returns 
 */
function subtractDayIntoDate(_date, subtractDays = 1) {
	const date = getDate(_date);
	date.setDate(date.getDate() - subtractDays);
	return date;
}

/**
 * returns date Difference In Months
 * @param {*} date1 
 * @param {*} date2 
 * @param {*} isWantNegative 
 * @returns 
 */
function getMonthsDiff(date1, date2, isWantNegative = false) {
	const d1 = getDate(date1);
	const d2 = getDate(date2);
	let months = 0;
	months = (d2.getFullYear() - d1.getFullYear()) * 12;
	months += d2.getMonth() - d1.getMonth();
	if (isWantNegative) return months;
	return months >= 0 ? months : 0;
}

/**
 * Add current timezone offset
 * @param {*} _date 
 * @returns 
 */
function getDate(_date) {
	const date = new Date(_date);
	date.setMinutes(date.getTimezoneOffset());
	return date;
}

/**
 * returns months between given range of date
 * @param {*} startDate 
 * @param {*} endDate 
 * @returns 
 */
function getAllMonthsInBetween(startDate = new Date(), endDate = new Date()) {
	const start = moment(startDate)
		.format("YYYY-MM-DD")
		.split("-");
	const end = moment(endDate)
		.format("YYYY-MM-DD")
		.split("-");
	const startYear = parseInt(start[0]);
	const endYear = parseInt(end[0]);
	const dates = [];

	for (let i = startYear; i <= endYear; i++) {
		const endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
		const startMon = i === startYear ? parseInt(start[1]) - 1 : 0;
		for (let j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j + 1) {
			const month = j + 1;
			const displayMonth = month < 10 ? "0" + month : month;
			dates.push(moment([i, displayMonth, "01"].join("-")).format("MMM YYYY"));
		}
	}
	return dates;
}

/**
 * returns date difference in months
 * @param {*} date1 
 * @param {*} date2 
 * @returns 
 */
function getDiffInMonths(date1,date2)
{
	const d1Y = new Date(date1).getFullYear();
	const d2Y = new Date(date2).getFullYear();
	const d1M = new Date(date1).getMonth();
	const d2M = new Date(date2).getMonth();

	return (d2M+12*d2Y)-(d1M+12*d1Y);
}

/**
 * returns date Difference In Days
 * @param {*} date1 
 * @param {*} date2 
 * @returns 
 */
function getDiffInDays(date1, date2) {
	if (!date1 || !date2) return -1;
	date1.setHours(1);
	date2.setHours(1);
	date1.setMinutes(0);
	date2.setMinutes(0);
	date1.setSeconds(0);
	date2.setSeconds(0);
	const diffTime = date2 - date1;
	const diffDays = Math.ceil((diffTime / (1000 * 60 * 60 * 24)).toFixed(4));
	return diffDays;
}

/**
 * Convert into MM/DD/YYYY
 * @param {*} date 
 * @returns 
 */
function convertAPIDateInStdFormat(date) {
	if (!date) return "";
	const spDate = date.split("-");
	return `${spDate[1]}/${spDate[2]}/${spDate[0]}`;
}

export {
	getTodaysDate,
	convertToLocalDate,
	getDate,
	addYearIntoDate,
	getMonthsDiff,
	addDayIntoDate,
	convertDateToFormat,
	subtractDayIntoDate,
	defaultAsofDate,
	getAsofDate,
	getAllMonthsInBetween,
	getDiffInDays,
	convertAPIDateInStdFormat,
	getDiffInMonths
};
